// 以下图形为可连接的控制点会出现在能包裹住该图形内部的形状，手动指定该控制点的出发方向以进行避让
export const SpecialShape = {
    trapezoid: [0, 3, 2, 1],
    moon: [0, 3, 2, 1],
    heptagon: [1, 1, 2, 2, 3, 3, 0],
    halfFrame: [1, 2, 3, 0],
    chord: [1, 0, 1],
    diagStripe: [1, 3, 3, 0],
    can: [0, 0, 3, 2, 1],
    cube: [0, 0, 3, 2, 1, 1],
    bevel: [1, 1, 2, 2, 3, 3, 0, 0],
    donut: [0, 3, 3, 2, 2, 1, 1, 0],
    noSmoking: [0, 3, 3, 2, 2, 1, 1, 0],
    mathMultiply: [3, 1, 1, 3],
    mathNotEqual: [1, 1, 2, 3, 3, 0],
    star7: [1, 1, 2, 2, 3, 3, 0],
    star8: [1, 1, 2, 2, 3, 3, 0, 0],
    star10: [1, 1, 2, 2, 2, 3, 3, 0, 0, 0],
    star12: [1, 1, 1, 2, 2, 2, 3, 3, 3, 0, 0, 0],
    star16: [1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 0, 0, 0, 0],
    wedgeEllipseCallout: [0, 0, 3, 2, 2, 1, 0, undefined],
    upDownArrow: [0, 3, 3, 3, 2, 1, 1, 1, 1],
    leftRightUpArrow: [0, 3, 2, 1],
    leftUpArrow: [0, 3, 0, 3, 2, 2, 1, 1],
    bentUpArrow: [0, 3, 3, 2, 1, 1],
    notchedRightArrow: [0, 3, 2, 1],
    arc: [undefined, 3, undefined],
    decagon: [1, 1, 1, 2, 2, 3, 3, 3, 0, 0],
    dodecagon: [1, 1, 1, 2, 2, 2, 3, 3, 3, 0, 0, 0],
    lightningBolt: [0, 3, 3, 3, 2, 1, 1],
    flowChartInputOutput: [0, 0, 3, 2, 2, 1],
    flowChartDocument: [0, 3, 2, 1],
    flowChartConnector: [0, 0, 3, 3, 2, 2, 1, 1],
    flowChartMultidocument: [0, 3, 2, 1],
    flowChartManualInput: [0, 3, 2, 1],
    flowChartManualOperation: [0, 3, 2, 1],
    flowChartPunchedTape: [0, 3, 2, 1],
    flowChartSummingJunction: [0, 0, 3, 3, 2, 2, 1, 1],
    flowChartOr: [0, 0, 3, 3, 2, 2, 1, 1],
    flowChartCollate: [0, 3, 2],
    flowChartExtract: [0, 3, 2, 1],
    flowChartMerge: [0, 3, 2, 1],
    flowChartOnlineStorage: [0, 3, 2, 1],
    flowChartMagneticDisk: [0, 0, 3, 2, 1],
    flowChartMagneticDrum: [0, 3, 2, 1, 1],
    ribbon2: [0, 3, 2, 1],
    ribbon: [0, 3, 2, 1],
    ellipseRibbon2: [0, 3, 2, 1],
    ellipseRibbon: [0, 3, 2, 1],
    verticalScroll: [0, 3, 2, 1],
    horizontalScroll: [0, 3, 2, 1],
    wave: [0, 3, 2, 1],
    doubleWave: [0, 3, 2, 1],
    smileyFace: [0, 0, 3, 3, 2, 2, 1, 1],
    heart: [0, 2],
    teardrop: [1, 2, 2, 2, 3, 3, 0, 0],
    bentArrow: [0, 2, 2, 1],
    uturnArrow: [2, 2, 1, 0, 2],
    circularArrow: [2, 1, 2, 2],
    cloudCallout: [3, 2, 1, 0, 2],
    curvedRightArrow: [3, 2, 1, 1, 1],
    curvedLeftArrow: [3, 3, 3, 2, 1],
    curvedUpArrow: [0, 0, 0, 2, 1],
    curvedDownArrow: [0, 2, 2, 2, 1],
    cloud: [1, 2, 3, 0],
};
